import type { SVGProps } from "react";
// generated from Last.svg — do not edit manually
// prettier-ignore
export default function Last(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 13 12 L 13.53 12.5303 L 14.061 12 L 13.53 11.4697 L 13 12 Z M 17 6 H 16.25 V 18 H 17 H 17.75 V 6 H 17 Z M 7 6 L 6.47 6.53033 L 12.47 12.5303 L 13 12 L 13.53 11.4697 L 7.53 5.46967 L 7 6 Z M 13 12 L 12.47 11.4697 L 6.47 17.4697 L 7 18 L 7.53 18.5303 L 13.53 12.5303 L 13 12 Z" fill="currentColor"/></svg>);
}
